import { Box, useMediaQuery } from "@mui/material"
import clsx from "clsx"
import { CoachingGoodToKnow } from "../subpages/CoachingGoodToKnow"
import { CoachingIntro } from "../subpages/CoachingIntro"
import { GZ, GZ2 } from "../subpages/GZ"
import { theme } from "../Theme"

export const CoachingMobile: React.FC = () => {
    const biggerThanSm = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <>
        <div className="slide">
          <div className={clsx({ 'fp-auto-height-responsive':true, "fp-bg2-1": biggerThanSm })}>
            <Box justifySelf='center' textAlign="center" display="flex" flexDirection="column" padding={'10%'} marginTop={'10%'} marginBottom={'10%'}>
              <CoachingIntro />
            </Box>
          </div>
        </div>
        <div className="slide">
          <div className={clsx({ 'fp-auto-height-responsive':true, "fp-bg2-2": biggerThanSm })}>
            <Box justifySelf='center' textAlign="left" display="flex" flexDirection="column" padding={'10%'} marginTop={'10%'} marginBottom={'10%'}>
                  <CoachingGoodToKnow />
            </Box>
          </div>
        </div>
        <div className='slide'>
        <div className={clsx({ 'fp-auto-height-responsive':true, "fp-bg2-1": biggerThanSm })}>
          <Box justifySelf='center' textAlign="left" display="flex" flexDirection="column" padding={'10%'} marginTop={'10%'} marginBottom={'10%'}>
            <GZ />
          </Box>
        </div>
      </div>
      <div className='slide'>
        <div className={clsx({ 'fp-auto-height-responsive':true, "fp-bg2-2": biggerThanSm })}>
          <Box justifySelf='center' textAlign="left" display="flex" flexDirection="column" padding={'10%'} marginTop={'10%'} marginBottom={'10%'}>
            <GZ2 />
          </Box>
        </div>
      </div>
      </>
    )
}